import { getEnv } from "../../AppConfigs";
import api from "../axiosBase";
import { RequestError } from "../requestError";
import { getURL } from "../serviceHelper";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_BUSINESS_TICKET_REQUEST_LIST_ID");

const expand =
  "expand=fields(select=Title, eBaseOnDecision, eDescription, eOffice, eWorkingTime, eFinishTime, eContent, eFileContent, ePassportContent, eTrip, eBaseOnDecision, eBaseOnProposal, eDeptHeadComment, eITLeadComment, eITHeadComment, eAssigneeComment, eApprovedBy, eApprovedDate,eApprovedStatus, eApprovedByITLead,eApprovedByITLeadStatus, eApprovedByITLeadDate,eApprovedByITHead ,eApprovedByITHeadStatus, eApprovedByITHeadDate, eAssignee,eAssigneeStatus,eAssigneeStatusDate, eRequestStatus, eRequestType, eSoftwareId, eDepartment, eUnit, ePhoneNumber, eComments, eTicketType, ePins, DepartmentScope, eSteps, refundFor)";
export class BusinessTicketRequestService {
  static async getBusinessTicketRequests(email: string, status?: string) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
      .then((res) => res.data.value)
      .catch((err) => {
        throw new RequestError(err);
      });

    // if (
    //   email.toLowerCase() === "botit@viags.vn" ||
    //   email.toLowerCase() === "huongptt@viags.vn" ||
    //   email.toLowerCase() === "hieptd@viags.vn" ||
    //   email.toLowerCase() === "anhttt@viags.vn" ||
    //   email.toLowerCase() === "thiennv@viags.vn" ||
    //   email.toLowerCase() === "huongdtt@viags.vn"
    // ) {
    //   return api
    //     .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
    //     .then((res) => res.data.value)
    //     .catch((err) => {
    //       throw new RequestError(err);
    //     });
    // } else {
    //   let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
    //   return api
    //     .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`))
    //     .then((res) => res.data.value)
    //     .catch((err) => {
    //       throw new RequestError(err);
    //     });
    // }
  }

  static async getBusinessTicketRequestsApprovalHistory(email: string) {
    let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`))
      .then((res) => res.data.value)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getMyBusinessTicketRequests(email: string) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
      .then((res) => res.data.value.filter((o: any) => o.createdBy.user.email.toLowerCase() === email.toLowerCase()))
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getBusinessTicketRequest(id: any) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async addBusinessTicketRequest(leaveRequest: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), leaveRequest)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async updateBusinessTicketRequest(id: any, fields: any) {
    return api
      .patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async deleteBusinessTicketRequest(id: any) {
    return api
      .delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getHistory(id: any) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/versions`))
      .then((res) => res.data.value)
      .catch((err) => {
        throw new RequestError(err);
      });
  }
}
